import { checkVisibility, GenericAiWidgetData, WidgetOutputMode } from '@playbooks/action-cards-utils'
import { Fragment, Section, WidgetType } from '@playbooks/core/src/interfaces/ActionCard'

import { useRef } from 'react'
import { WidgetContext } from '../widgets/widgetTypes'
import Widget from '../widgets/widget'
import useReplacements from '../../hooks/useReplacements'
import { useAppContext } from '../../contexts/AppContext'
import useScopeSections from '../../hooks/useScopeSections'

interface RecommendationProps {
  data: Fragment
  sectionData: Section
}

export default function Recommendation({ data, sectionData }: RecommendationProps) {
  const { data: actionCardsData, actionCardsModel } = useAppContext()
  const containerWithItsOwnStyles = useRef<HTMLDivElement | null>(null)
  const headerScopeSections = useScopeSections(actionCardsModel, sectionData)

  const widgets =
    data.widgets?.filter(widget => {
      // If the widget type is RecommendPlaybooks we do not show it (#14490)
      if (widget.type === WidgetType.RecommendPlaybooks) return false
      return checkVisibility(widget, actionCardsData)
    }) || []

  // Get the generated text to replace the original recommendation text with (#10482)
  const generatedText = (widgets || [])
    .filter(w => w.type === WidgetType.GenericAiPrompt)
    .filter(w => (w as GenericAiWidgetData).outputMode == WidgetOutputMode.Replace && (w as GenericAiWidgetData).value)
    .toSorted((a, b) => ((b as GenericAiWidgetData)?.updatedAt ?? 0) - ((a as GenericAiWidgetData)?.updatedAt || 0))
    .map(w => (w as GenericAiWidgetData).value)[0]

  // Prepare context data for widgets (#10482)
  const widgetContext: WidgetContext = {
    allWidgets: widgets,
    visibleText: generatedText || data.text || null,
    originalText: data.text || null,
    section: sectionData,
    headerScopeSections,
  }

  useReplacements(containerWithItsOwnStyles, generatedText || data.text || '', [widgetContext.visibleText])

  return (
    <div className="relative">
      <div
        data-recommendation-html-container
        ref={containerWithItsOwnStyles}
        className="relative z-0 isolated-html-content rte-shadow-root-container"
      />
      {/* Section's widgets (#8109) */}
      {widgets.length > 0 && (
        <div className="flex flex-col gap-1 clear-both">
          {widgets.map(widget => (
            <div key={widget.id} className="my-1">
              <Widget widget={widget} context={widgetContext} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
